import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputNumber } from '@sm360/widget-commons-forms';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { LocalStorageService } from '@sm360/widget-commons-general';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorCashdown/CalculatorCashdown.scss';

class CalculatorCashdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cashdown:
                parseInt(LocalStorageService.get('cashDown'), 10) || props.purchaseMethods.getSelectedFinanceCashDown(),
        };

        this.onInputChange = this.onInputChange.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            cashdown: newProps.purchaseMethods.getSelectedFinanceCashDown(),
        });
    }

    onInputChange(value) {
        const cashdown = parseFloat(Math.round(value * 100) / 100);
        this.setState({
            cashdown,
        });
        LocalStorageService.set('cashDown', cashdown);
        this.props.setCashDown(cashdown);
    }

    render() {
        const defaultCashdown = parseFloat(this.state.cashdown);
        return (
            <div className="calculator-cash-down is-light">
                <div className="calculator-cash-down-title">
                    {LocaleService.t('PAYMENT_CALCULATOR.INITIAL_CASHDOWN')}
                </div>
                <div className="calculator-cash-down-wrapper">
                    <InputNumber
                        min={0}
                        onChange={this.onInputChange}
                        step={250}
                        value={defaultCashdown ? defaultCashdown.toFixed(2) : '0'}
                        decimalCount={2}
                        label="CASHDOWN"
                        showLabel={false}
                    />
                </div>
            </div>
        );
    }
}

CalculatorCashdown.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    setCashDown: PropTypes.func.isRequired,
};

CalculatorCashdown.displayName = 'CalculatorCashdown';

export default CalculatorCashdown;



// WEBPACK FOOTER //
// ./src/components/PaymentCalculatorDetails/components/CalculatorCashdown/CalculatorCashdown.jsx